/* eslint-disable no-unused-vars */
/* eslint-disable array-bracket-spacing */
/* eslint-disable max-len */
import { ChooseLocationOnboardingFormType, ChooseLocationSchema } from "../../services/location/location.schema";
import React, { useEffect, useState } from "react";
import { useFormattedLocation, useLocationDirectionsV2 } from "../../services/location/location.service";

import ChooseLocationListView from "../ChooseLocationListView/ChooseLocationListView";
import GvInputController from "../Controllers/GvInputController/GvInputController";
import { ILocationDirection, ILocationSearchPrediction } from "../../services/location/location.interface";
import ListIcon from "../Icons/ListIcon";
import Loading from "../Loading/Loading";
import LocationSearchNew from "../LocationSearchNew/LocationSearchNew";
import MapIcon from "../Icons/MapIcon";
import MapMini from "../MapMini/MapMini";
import { useForm } from "react-hook-form";
import { useGTM } from "../../hooks/useGTM";
import { useUserCreateStore } from "../../hooks/redux-hooks/user-create-store/user-create.store";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";
import { yupResolver } from "@hookform/resolvers/yup";

interface ILocationModalMap {
  onSubmit: (data:any) => void
  setMsa: (data: string) => void
  setSelectedLocationName: (data: string) => void
}


const ChooseLocationForm: React.FC<ILocationModalMap> = ({ onSubmit, setMsa, setSelectedLocationName }) => {
  const [markers, setMarkers] = useState<any[]>([]);
  const [mapData, setMapData] = useState<any>();
  const [markerClick, setMarkerClick] = useState();
  const [isBubble, setIsBubble] = useState<boolean>(false);
  const [selectedLocation, setSelectedLocation] = useState<{ location: any } | null>(null);
  const [modalViaBubble, setModalViaBubble] = useState<boolean>(false);
  const [valueInForm, setValueInForm] = useState<any>();
  const [showMapView, setShowMapView] = useState(false);
  const { findDirectionsV2, directionsV2, totalPages, loading } = useLocationDirectionsV2();
  const { createProfile } = useUserStore();
  const { setLocation } = useUserCreateStore();
  const { findFormatedLoction, searchData } = useFormattedLocation();
  const [showAddressFields, setShowAddressFields] = useState<boolean>(false);
  const [isTextFieldSelected, setIsTextFieldSelected] = useState<boolean>(false);
  const { dispatchEvent } = useGTM();
  const [ directionsPageShown, setDirectionsPageShown ] = useState<number>(1);
  const [ totalDirectionPage, setTotalDirectionsPage ] = useState<number>(0);
  const [ currentPlaceId, setCurrentPlaceId ] = useState<string>("");
  const [ locationList, setLocationList ] = useState<ILocationDirection[]>([]);
  const { control, getValues, setValue, clearErrors } = useForm<ChooseLocationOnboardingFormType>({
    mode: "onChange",
    resolver: yupResolver(ChooseLocationSchema),
    defaultValues: {
      location: "",
    },
  });

  const handleSubmit2 = (form: ChooseLocationOnboardingFormType) => {
    setSelectedLocationName(form.location);
    setValue("location", form.locationId!);
  };

  const uplifting = (value: any) => {
    setValueInForm(value);
  };

  const handleMarkerClick = (mark: any) => {
    setIsBubble(true);
    setSelectedLocation(mark);
    setLocation(mark.idLocation);
    setMarkerClick(mark);
    setMapData(mark.position);
    valueInForm && valueInForm();
    setMsa(mark.cityName);
    setSelectedLocationName(mark.locationName);
  };


  const handleOpenLocationModal = () => {
    setModalViaBubble(!modalViaBubble);
  };

  const handleToggle = () => {
    setShowMapView(!showMapView);
  };

  const handleViewMoreLocationsCta = () =>{
    if (directionsPageShown !== totalPages) {
      setDirectionsPageShown(directionsPageShown + 1);
    }
  };

  const handleLocationSearch = (place: ILocationSearchPrediction) => {
    dispatchEvent({
      eventName: "gv_choose_address",
      eventProps: {
        addressValue: place.description,
      },
    });
    if (!(place.place_id === "" || null)) {
      findDirectionsV2(place.place_id);
      setDirectionsPageShown(1);
      setLocationList([]);
      setCurrentPlaceId(place.place_id);
    }
    setValue("placeId", place?.place_id || "");
    findFormatedLoction(place?.place_id || "");
    setValue("address", place?.description || "");
    setValue("placeId", place.place_id );
    if (getValues("placeId")) {
      setShowAddressFields(true);
    }
  };

  useEffect(() => {
    if (createProfile?.placeId) {
      findDirectionsV2(createProfile?.placeId);
      setDirectionsPageShown(1);
      setLocationList([]);
      setCurrentPlaceId(createProfile?.placeId);
    }
  }, [createProfile?.placeId]);

  useEffect(() => {
    if (searchData) {
      setValue("streetAddress", searchData?.streetAddress, { shouldValidate: true });
      setValue("townCity", searchData?.townCity, { shouldValidate: true });
      setValue("zipCode", searchData?.zipCode, { shouldValidate: true });
      setValue("country", "US", { shouldValidate: false });
      clearErrors(["address"]);
    }
  }, [searchData]);

  useEffect(() => {
    if (directionsV2?.length && totalPages && currentPlaceId.length) {
      findDirectionsV2(currentPlaceId, directionsPageShown);
    }
  }, [directionsPageShown]);

  useEffect(() => {
    if (directionsV2?.length && totalPages) {
      setTotalDirectionsPage(totalPages);
      setLocationList((prev) => [...prev, ...directionsV2.filter((hospital)=>!hospital.isOnlyUrgentVisit)]);
    }
  }, [directionsV2]);

  const handleSetLocationSubmit = () => {
    onSubmit(getValues());
  };

  return (
    <div className="flex flex-col w-full h-full items-center grow overflow-y-auto">

      <div className="
      overflow-scroll scroll-hide w-full h-full my-2">
        <div className={`${isTextFieldSelected ? "!p-2 !border-taupe-2 !border !rounded-lg" : undefined}`}>
          <LocationSearchNew
            disable={true}
            id="locationSearchHospitals"
            onSelect={handleLocationSearch}
            searchValue={createProfile?.address || ""}
            control={control}
            setIsBubble={setIsBubble}
            setIsTextFieldSelected={setIsTextFieldSelected}
            label="Your address"
          />
          {showAddressFields && (
            <>
              <GvInputController
                control={control}
                name="streetAddress"
                label="Street address"
                placeholder="Enter Street Address"
                className="font-semibold"
              />
              <GvInputController
                control={control}
                name="townCity"
                label="Town/City"
                placeholder="Enter Town/City"
                className="font-semibold"
              />
              <GvInputController
                control={control}
                name="zipCode"
                label="Zip Code"
                placeholder="Enter Zip Code"
                className="font-semibold"
              />
            </>

          )}
        </div>

        <div className="flex justify-between my-6 mb-1.5">
          <div className=" text-sm text-gray-1 mt-[-0.2rem]">Nearest Hospitals</div>
          <div
            className="w-[3.75rem] h-[1.75rem] flex gap-1 bg-white
            rounded-lg mt-[-0.5rem] p-1 border border-1 border-[#E8DFD7]"
            onClick={() => handleToggle()}
          >
            <span className={`rounded-lg p-1 ${showMapView ? "bg-[#F4EFEB]" : ""}`}><span
              className="relative bottom-[2px]"><MapIcon /></span></span>
            <span className={`rounded-lg p-1 ${!showMapView ? "bg-[#F4EFEB]" : ""}`}><span
              className="relative bottom-[3px]"><ListIcon /></span></span>
          </div>
        </div>
        <div className="flex-grow scroll-hide">
          {loading && !locationList.length && <Loading/>}
          {locationList.length ? (showMapView ? (
            <MapMini
              lat={mapData?.lat}
              lng={mapData?.lng}
              markers={markers}
              mapData={mapData}
              onClick={handleMarkerClick}
              isBubble={isBubble}
              location={selectedLocation}
              setIsBubble={setIsBubble}
              handleUpdateLocationDetail={handleOpenLocationModal}
              height="15rem"
            />
          ) : (
            <>
              <ChooseLocationListView
                setMsa={setMsa}
                onSubmit={handleSubmit2}
                setMapData={setMapData}
                setShowMap={()=>{}}
                setMarkers={setMarkers}
                markerClick={markerClick}
                modalViaBubble={modalViaBubble}
                location={selectedLocation}
                setIsBubble={setIsBubble}
                setValueInForm={uplifting}
                directions={locationList}
                control={control}
                getCurrentLocationId={getValues}
                handleSetLocationSubmit={handleSetLocationSubmit}
                handleViewMoreLocationsCta={handleViewMoreLocationsCta}
                isCtaDisabled={directionsPageShown === totalPages}
                loading={loading && locationList.length ? true : false}
              />
            </>
          )) : (
            <div className="p-6 bg-taupe-15 text-wrap text-center rounded-xl my-4">
              Enter your address to find the closest GoodVets hospitals to you.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChooseLocationForm;
